module.exports = __webpack_public_path__ + "static/where-to-buy-bg-4861882c6e5b543f4118f44c858841d5.jpg";